define('glu/flexDropdown/views/flexDropdownTooltipItemView',['require','../../itemView','hbs!./flexDropdownTooltipItemView.hbs','../../util'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        tmpl = require('hbs!./flexDropdownTooltipItemView.hbs'),
        util = require('../../util');

    return ItemView.extend({
        template: tmpl,
        tagName: 'ul',

        templateHelpers: function() {
            return {
                isDefaultSelected: this.isDefaultSelected()
            };
        },

        isDefaultSelected: function() {
            var modelId = this.model.id;
            // can't use !this.model.id , because this.model.id can be equal 0;
            return util.isNull(modelId) || util.isUndefined(modelId) || modelId === '';
        }
    });
});

